import { Position, PositionRange } from '../types'

export function getPositionRange(position: Position, another: Position): PositionRange {
  return position > another ? [another, position] : [position, another]
}
